import React from 'react';
import Image from 'next/image';
import GenericForm from '@/components/GenericForm';

import consultationImg from '@/public/formpopup/consultationImg.webp';

function BookConsultation() {
  return (
    <div
      className='
        lg:px=[44px]  bg-gradient-135  dark:to-68% hidden h-[300px] 
        rounded-[30px] bg-gradient-to-br from-[#e3f4fb] to-[#c8f0f5] dark:bg-gradient-to-tr  dark:from-[#374a57] dark:from-10% dark:to-[#263843] lg:mb-[120px]
        lg:mt-[60px] lg:flex lg:justify-center lg:px-[45px] lg:py-[25px] '
    >
      <div className=''>
        <h3 className=' min-w-[325px] text-[34px] font-semibold leading-[1.33] tracking-[-0.48px] text-[#1c2534] dark:text-[#fff] '>
          Get a Callback
        </h3>
        <GenericForm
          cta='INTERNAL_BLOG_PAGE'
          contactFormbuttonBg='bg-[#00b4b9]'
          formType='APPOINMENT_FORM'
        />
      </div>
      <div className='flex items-baseline'>
        <Image
          src={consultationImg}
          alt='girl image'
          className=' ml-[-50px] mt-[9px] max-[1410px]:hidden lg:max-w-[290px]'
        ></Image>
      </div>
    </div>
  );
}

export default BookConsultation;
